(function () {

  function loadData() {
    var dataEl = document.getElementById('aa-variant-data');

    if (!dataEl) return null;

    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      console.log('aa: failed to parse variant data', e);
      return null;
    }
  }

  function setOrHide(el, html) {
    if (!el) return;

    if (html && html.trim() !== '') {
      el.innerHTML = html;
      el.style.display = '';
    } else {
      el.innerHTML = '';
      el.style.display = 'none';
    }
  }

  function updateScent(variantId) {

    if (!variantId) return;

    if (String(variantId) === String(window._lastVariantId)) return;

    window._lastVariantId = String(variantId);

    var data = loadData();

    if (!data) {
      console.log('aa: no data found');
      return;
    }

    var meta = data.variants[String(variantId)] || {};

    var tagline = meta.scent_tagline || '';
    var notes   = meta.scent_notes || '';
    var desc    = meta.scent_description || '';

    var hasScentDescription = desc && desc.trim() !== '';

    var elTagline = document.getElementById('aa-scent-tagline');
    var elNotes   = document.getElementById('aa-scent-notes');
    var elDesc    = document.getElementById('aa-scent-desc');

    setOrHide(elTagline, tagline);

    setOrHide(
      elNotes,
      notes ? '<strong>Notes:</strong> ' + notes : ''
    );

    if (hasScentDescription) {

      setOrHide(elDesc, desc);

      if (elDesc) {
        elDesc.classList.add('scent-desc');
        elDesc.classList.remove('default-product-description');
      }

    } else {

      setOrHide(
        elDesc,
        data.defaultDescription || ''
      );

      if (elDesc) {
        elDesc.classList.remove('scent-desc');
        elDesc.classList.add('default-product-description');
      }

    }

  }

  function findVariantId() {

    var fromUrl = new URLSearchParams(window.location.search).get('variant');

    if (fromUrl) return fromUrl;

    var input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (input && input.value) return input.value;

    return null;
  }

  function init() {

    var initial = findVariantId();

    if (initial) {
      updateScent(initial);
    }

    var input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (input) {

      try {

        var descriptor = Object.getOwnPropertyDescriptor(
          HTMLInputElement.prototype,
          'value'
        );

        Object.defineProperty(input, 'value', {

          get: function () {
            return descriptor.get.call(this);
          },

          set: function (val) {
            descriptor.set.call(this, val);
            updateScent(val);
          },

          configurable: true

        });

      } catch (e) {}

    }

    document.addEventListener('click', function () {

      setTimeout(function () {

        var id = findVariantId();

        if (id) {
          updateScent(id);
        }

      }, 100);

    });

    setInterval(function () {

      var id = findVariantId();

      if (id && id !== window._lastVariantId) {
        updateScent(id);
      }

    }, 200);

    [
      'on:variant:change',
      'variant:change',
      'variantChange'
    ].forEach(function (name) {

      document.addEventListener(name, function (e) {

        var id =
          e.detail &&
          (
            (e.detail.variant && e.detail.variant.id) ||
            e.detail.variantId
          );

        if (id) {

          updateScent(id);

        } else {

          setTimeout(function () {

            var found = findVariantId();

            if (found) {
              updateScent(found);
            }

          }, 50);

        }

      });

    });

    var origPush = history.pushState;

    history.pushState = function () {

      origPush.apply(this, arguments);

      setTimeout(function () {

        var id = findVariantId();

        if (id) {
          updateScent(id);
        }

      }, 50);

    };

    window.addEventListener('popstate', function () {

      setTimeout(function () {

        var id = findVariantId();

        if (id) {
          updateScent(id);
        }

      }, 50);

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();